module.exports = __webpack_public_path__ + "static/media/GuruprasadVenkatraman.0bf855d1.jpg";